export default __webpack_public_path__ + "static/media/disconnected.1f5832c8.mp3";